import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { masterApi, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/PasswordInput";

export default function ForcePassword() {
  const { updateMaster, master } = useAuth();
  const navigate = useNavigate();
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");

  const submit = async () => {
    if (nw.length < 6) return toast.error("New password must be at least 6 characters");
    try {
      await masterApi.post("/auth/change-password", { current: cur, new: nw });
      updateMaster({ must_change_password: false });
      toast.success("Password updated");
      navigate("/pin");
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-5">
      <div className="w-full max-w-sm bg-white border border-slate-200 rounded-3xl p-6 shadow-xl space-y-4">
        <h1 className="text-xl font-extrabold text-slate-900 font-head">Change your password</h1>
        <p className="text-sm text-slate-500">You're using default credentials for {master?.shop_name}. Please set a new password to continue.</p>
        <PasswordInput data-testid="force-current" placeholder="Current password" value={cur} onChange={(e) => setCur(e.target.value)} className="h-12 bg-slate-50 border-slate-200" />
        <PasswordInput data-testid="force-new" placeholder="New password" value={nw} onChange={(e) => setNw(e.target.value)} className="h-12 bg-slate-50 border-slate-200" />
        <Button data-testid="force-submit" onClick={submit} className="w-full h-12 bg-blue-600 hover:bg-blue-700 text-white font-bold">Update & Continue</Button>
      </div>
    </div>
  );
}
